"use strict";

exports.__esModule = true;
exports.default = void 0;
var _baseCreate = _interopRequireDefault(require("./_baseCreate.js"));
var _getPrototype = _interopRequireDefault(require("./_getPrototype.js"));
var _isPrototype = _interopRequireDefault(require("./_isPrototype.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return typeof object.constructor == 'function' && !(0, _isPrototype.default)(object) ? (0, _baseCreate.default)((0, _getPrototype.default)(object)) : {};
}
var _default = exports.default = initCloneObject;